<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card :title="title" :color="$vuetify.theme.themes.light.success" icon="add" v-if="hours">
        <v-card-text v-if="plans">
          <v-form v-model="valid" v-if="model">
            <v-row justify-center>
              <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                <v-autocomplete
                  :label="$t('globals.plan')"
                  v-model="hours.PlanIdentity"
                  :items="plans"
                  item-text="UniqueIdentifier"
                  item-value="Id"
                  hide-details
                  clearable
                  return-object
                  :rules="[$rules.required]"
                  class="required"
                  :loading="loading"
                  v-if="
                    hours.PlanIdentityId === null ||
                    hours.PlanIdentityId === undefined
                  "
                ></v-autocomplete>
                <span v-else>
                  {{ hours.PlanIdentity.UniqueIdentifier }}
                </span>
              </div>
              <div
                class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                v-if="hours.PlanIdentity || hours.PlanIdentityId"
              >
                <trans-select2
                  v-model="hours"
                  propertyName="MemberGroup"
                  :clearable="true"
                  :items="memberGroups"
                  :label="$t('globals.member_group')"
                  field="Name"
                  itemValue="IdentityId"
                ></trans-select2>
              </div>
              <div
                class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                v-if="hours.PlanIdentity || hours.PlanIdentityId"
              >
                <pbas-date-picker
                  :label="$t('globals.effective_date')"
                  :value="effectiveDate"
                  @update-date="effectiveDate = $event"
                  :rules="[$rules.required]"
                  class="required"
                  :allowedDates="coverageAllowedDates"
                ></pbas-date-picker>
              </div>
            </v-row>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{
                          $t("components.sick_payment_settings.sick_hours_bank")
                        }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify-center>
                    <template v-if="hours.EffectiveDate">
                      <div
                        class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                        v-if="!hours.SickDaysPerYear"
                      >
                        <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.sick_payment_settings.maximum_accumulated_hours'
                            )
                          "
                          :value.sync="hours.MaximumAccumulatedHours"
                          :rules="[$rules.integer, $rules.dynamic.minValue(0)]"
                          clearable
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                        v-if="!hours.SickDaysPerYear"
                      >
                        <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.sick_payment_settings.maximum_threshold'
                            )
                          "
                          :value.sync="hours.MaximumThreshold"
                          :rules="[$rules.integer, $rules.dynamic.minValue(0)]"
                          clearable
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                        v-if="!hours.MaximumAccumulatedHours"
                      >
                        <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.sick_payment_settings.sick_days_per_year'
                            )
                          "
                          :value.sync="hours.SickDaysPerYear"
                          :rules="[$rules.integer, $rules.dynamic.minValue(0)]"
                          clearable
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.sick_payment_settings.hours_per_sick_day'
                            )
                          "
                          :value.sync="hours.HoursPerSickDay"
                          :rules="[
                            $rules.requiredInteger,
                            $rules.dynamic.minValue(0),
                          ]"
                          class="required"
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <v-checkbox
                          :label="
                            $t(
                              'headers.sick_payment_settings.supports_half_days'
                            )
                          "
                          v-model="hours.SupportsHalfDays"
                        ></v-checkbox>
                      </div>
                      <div
                        class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                        v-if="hours.SupportsHalfDays"
                      >
                        <no-autocomplete-textfield
                          :label="
                            $t('headers.sick_payment_settings.hours_to_deduct')
                          "
                          :value.sync="hours.HoursToDeduct"
                          :rules="[$rules.integer, $rules.dynamic.minValue(0)]"
                          clearable
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <v-checkbox
                          :label="
                            $t(
                              'headers.sick_payment_settings.has_to_be_eligible'
                            )
                          "
                          v-model="hours.HasToBeEligible"
                        ></v-checkbox>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <v-checkbox
                          :label="
                            $t(
                              'headers.sick_payment_settings.has_to_have_been_eligible'
                            )
                          "
                          v-model="hours.HasToHaveBeenEligible"
                        ></v-checkbox>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <no-autocomplete-textfield
                          :label="
                            $t('headers.sick_payment_settings.days_for_warning')
                          "
                          :value.sync="hours.DaysForWarning"
                          :rules="[$rules.integer, $rules.dynamic.minValue(0)]"
                          clearable
                        ></no-autocomplete-textfield>
                      </div>
                    </template>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{
                          $t(
                            "components.sick_payment_settings.sick_day_submission"
                          )
                        }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify-center>
                    <template v-if="submission && hours.EffectiveDate">
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.sick_payment_settings.maximum_days_per_claim_submission'
                            )
                          "
                          :value.sync="submission.MaximumDaysPerClaimSubmission"
                          :rules="[$rules.integer, $rules.dynamic.minValue(0)]"
                          clearable
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                        v-if="hours.SupportsHalfDays"
                      >
                        <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.sick_payment_settings.half_day_percentage'
                            )
                          "
                          :value.sync="submission.HalfDayPercentage"
                          :rules="[$rules.decimal, $rules.dynamic.minValue(0)]"
                          clearable
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <v-checkbox
                          :label="
                            $t(
                              'headers.sick_payment_settings.requires_doctors_note'
                            )
                          "
                          v-model="submission.RequiresDoctorsNote"
                        ></v-checkbox>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <v-checkbox
                          :label="
                            $t(
                              'headers.sick_payment_settings.requires_sick_day_form'
                            )
                          "
                          v-model="submission.RequiresSickDayForm"
                        ></v-checkbox>
                      </div>
                    </template>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{
                          $t(
                            "components.sick_payment_settings.sick_day_adjudication"
                          )
                        }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <template v-if="adjudication && hours.EffectiveDate">
                    <v-row justify-center>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <trans-enum
                          :value.sync="adjudication.SickDayLimitUnit"
                          :items="options.Enums.SickDayLimitUnit"
                          :label="
                            $t(
                              'headers.sick_payment_settings.sick_day_limit_unit'
                            )
                          "
                          :rules="[$rules.required]"
                          class="required"
                        ></trans-enum>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-8 col-lg-9">
                        <sick-payment-limits-table
                          :items="adjudication.Limits"
                          @update="adjudication.Limits = $event"
                        />
                      </div>
                    </v-row>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')" :loading="saving">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid"
            :loading="saving"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <!-- <v-dialog scrollable v-model="loading" persistent max-width="200">
        <v-card>
          <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row justify-center>
                <v-flex xs12 sm6 md4 lg3>
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog> -->
  </div>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import CurrencyTextfield from "../CurrencyTextfield.vue";
import TransSelect2 from "@/components/TransSelect2.vue";
import SickPaymentLimitsTable from "./SickPaymentLimitsTable.vue";
import TransEnum from "@/components/TransEnum.vue";

export default {
  props: ["model", "id", "brokerId"],
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransSelect2,
    CurrencyTextfield,
    SickPaymentLimitsTable,
    TransEnum,
  },
  data() {
    return {
      effectiveDate: null,
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      plans: [],
      loading: false,
      submission: null,
      adjudication: null,
      hours: null,
      memberGroups: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options", "planIdentity"]),
    title() {
      if (this.hours && this.hours.Id) {
        return this.$t("globals.edit");
      }
      return this.$t("globals.add");
    },
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadPlans();
          console.log(this.hours);
        }
      },
    },
    effectiveDate: {
      handler(v) {
        if (v && !this.loading) {
          this.updateDate(v);
        }
      },
    },
    "hours.MemberGroup": {
      handler(v) {
        if (v && !this.loading && this.effectiveDate) {
          this.loadByEffectiveDate(this.effectiveDate);
        }
      },
    },
    "hours.PlanIdentity": {
      handler(v) {
        if (v) {
          this.loadMemberGroups(v.Id);
        }
      },
    },
  },
  mounted() {
    this.loadPlans();
  },
  methods: {
    ...mapActions("plansMembers", [
      "getPlansThatHaveSickBank",
      "getSickHourBankSettingsByEffectiveDate",
      "addSickHourBankSettings",
      "updateSickHourBankSettings",
      "getMemberGroups",
      "getSickHourBankSettingsById",
      "getSickDaySubmissionSettingsByEffectiveDate",
      "getSickDaySubmissionSettingsById",
      "getSickDayAdjudicationSettingsByEffectiveDate",
      "getSickDayAdjudicationSettingsById",
    ]),
    ...mapActions("plansMembers", ["validateBankAccount", "getPlan"]),
    coverageAllowedDates(val) {
      // const n = Date.parse(val);
      // const d = new Date(n);
      // let n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      // const d2 = new Date(n2);
      // console.log(this.planIdentity)
      // return d >= d2;
      return true;
    },
    async loadPlans() {
      this.loading = true;
      try {
        this.plans = (
          await this.getPlansThatHaveSickBank({
            brokerId: this.brokerId,
          })
        ).data;
        if (this.id) {
          this.hours = (
            await this.getSickHourBankSettingsById({
              id: this.id,
            })
          ).data;
          this.hours.PlanIdentity = this.plans.filter(
            (o) => o.Id === this.hours.PlanIdentityId
          )[0];

          let submission = (
            await this.getSickDaySubmissionSettingsByEffectiveDate({
              planIdentityId: this.hours.PlanIdentityId,
              effectiveDate: this.hours.EffectiveDate,
              payload: {
                MemberGroupIdentityId: this.hours.MemberGroupIdentityId,
              },
            })
          ).data;
          if (
            submission !== null &&
            submission !== undefined &&
            submission !== ""
          ) {
            this.submission = submission;
          } else {
            this.submission = {};
          }

          let adjudication = (
            await this.getSickDayAdjudicationSettingsByEffectiveDate({
              planIdentityId: this.hours.PlanIdentityId,
              effectiveDate: this.hours.EffectiveDate,
              payload: {
                MemberGroupIdentityId: this.hours.MemberGroupIdentityId,
              },
            })
          ).data;
          if (
            adjudication !== null &&
            adjudication !== undefined &&
            adjudication !== ""
          ) {
            this.adjudication = adjudication;
          } else {
            this.adjudication = {};
          }

          this.effectiveDate = this.hours.EffectiveDate;
        } else {
          this.hours = {};
          this.submission = {};
          this.adjudication = {};
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
        console.log(this.hours);
      }
    },
    async loadMemberGroups(planIdentityId) {
      this.loading = true;
      try {
        this.memberGroups = (
          await this.getMemberGroups({
            plan: planIdentityId,
            url: "?$expand=Translations",
          })
        ).data.value;
        if (this.id) {
          this.hours.MemberGroup = this.memberGroups.filter(
            (o) => o.IdentityId === this.hours.MemberGroupIdentityId
          )[0];
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.$nextTick(() => {
          this.loading = false;
        });
      }
    },
    updateDate(v) {
      this.hours.EffectiveDate = v;
      console.log("*******************************************", v);
      if (v) {
        this.loadByEffectiveDate(v);
      }
    },
    async loadByEffectiveDate(effectiveDate) {
      this.loading = true;
      let planIdentityId = this.hours.PlanIdentityId;
      if (planIdentityId === null || planIdentityId === undefined) {
        planIdentityId = this.hours.PlanIdentity.Id;
      }
      let memberGroupIdentityId = this.hours.MemberGroupIdentityId;
      if (
        memberGroupIdentityId === null ||
        (memberGroupIdentityId === undefined && this.hours.MemberGroup)
      ) {
        memberGroupIdentityId = this.hours.MemberGroup.IdentityId;
      }
      try {
        let hours = (
          await this.getSickHourBankSettingsByEffectiveDate({
            planIdentityId: planIdentityId,
            effectiveDate: effectiveDate,
            payload: {
              MemberGroupIdentityId: memberGroupIdentityId
                ? memberGroupIdentityId
                : "00000000-0000-0000-0000-000000000000",
            },
          })
        ).data;
        console.log("hours is: ", hours);
        if (hours !== null && hours !== undefined && hours !== "") {
          this.hours = hours;
          this.hours.MemberGroup = this.memberGroups.filter(
            (o) => o.IdentityId === this.hours.MemberGroupIdentityId
          )[0];
        }
        let submission = (
          await this.getSickDaySubmissionSettingsByEffectiveDate({
            planIdentityId: planIdentityId,
            effectiveDate: effectiveDate,
            payload: {
              MemberGroupIdentityId: memberGroupIdentityId
                ? memberGroupIdentityId
                : "00000000-0000-0000-0000-000000000000",
            },
          })
        ).data;
        if (
          submission !== null &&
          submission !== undefined &&
          submission !== ""
        ) {
          this.submission = submission;
        } else {
          this.submission = {};
        }
        let adjudication = (
          await this.getSickDayAdjudicationSettingsByEffectiveDate({
            planIdentityId: planIdentityId,
            effectiveDate: effectiveDate,
            payload: {
              MemberGroupIdentityId: memberGroupIdentityId
                ? memberGroupIdentityId
                : "00000000-0000-0000-0000-000000000000",
            },
          })
        ).data;
        if (
          adjudication !== null &&
          adjudication !== undefined &&
          adjudication !== ""
        ) {
          this.adjudication = adjudication;
        } else {
          this.adjudication = {};
        }
        console.log(this.adjudication);
      } catch (error) {
        this.error = error;
      } finally {
        this.$nextTick(() => {
          this.loading = false;
        });
      }
    },
    save() {
      let hours = JSON.parse(JSON.stringify(this.hours));
      this.submission.MaximumAccumulatedHours = hours.MaximumAccumulatedHours;
      this.submission.SupportsHalfDays = hours.SupportsHalfDays;
      this.submission.HoursPerSickDay = hours.HoursPerSickDay;
      if (hours.MemberGroup) {
        hours.MemberGroupIdentityId = hours.MemberGroup.IdentityId;
        delete hours.MemberGroup;
        this.submission.MemberGroupId = hours.MemberGroupIdentityId;
        this.adjudication.MemberGroupId = hours.MemberGroupIdentityId;
      } else {
        hours.MemberGroupIdentityId = "00000000-0000-0000-0000-000000000000";
        this.submission.MemberGroupId = "00000000-0000-0000-0000-000000000000";
        this.adjudication.MemberGroupId =
          "00000000-0000-0000-0000-000000000000";
      }
      if (hours.Id) {
        delete hours.PlanIdentity;
        return this.update(hours);
      }
      hours.PlanIdentityId = hours.PlanIdentity.Id;
      this.submission.PlanId = hours.PlanIdentityId;
      this.adjudication.PlanId = hours.PlanIdentityId;
      this.adjudication.EffectiveDate = hours.EffectiveDate;
      this.submission.EffectiveDate = hours.EffectiveDate;
      delete hours.PlanIdentity;
      return this.add(hours);
    },
    async add(hours) {
      try {
        this.saving = true;
        await this.addSickHourBankSettings({
          payload: {
            SickHourBankSettings: hours,
            SickDaySubmissionSettings: this.submission,
            SickDayAdjudicationSettings: this.adjudication,
          },
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.$emit("saved");
      }
    },
    async update(hours) {
      try {
        this.saving = true;
        await this.updateSickHourBankSettings({
          id: hours.Id,
          payload: {
            SickHourBankSettings: hours,
            SickDaySubmissionSettings: this.submission,
            SickDayAdjudicationSettings: this.adjudication,
          },
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.$emit("saved");
      }
    },
  },
};
</script>

<style scoped></style>
